import NoContent from '../../assets/images/monitoring_no_content.png';
import { Box, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';

export const WidgetNoData = () => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
      <img
        src={NoContent}
        alt="No content"
        style={{ width: '50%', height: 'auto' }}
      />
      <Typography
        variant="body1"
        color={theme.palette.primary.main}
        fontWeight="bolder"
      >
        {t('widget_no_data')}
      </Typography>
    </Box>
  );
};
